module.exports = __webpack_public_path__ + "static/media/Chess123Icon.cd566d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Chess123Icon.png
// module id = 79
// module chunks = 0